module.exports = __webpack_public_path__ + "static/img/QR2.4d39cc98.jpg";